import { getBaseQuery, getBaseUrl } from '../../Utils';
import { createApi } from '@reduxjs/toolkit/query/react';
interface formData {
  name: string;
  description: string;
  sourceId: string;
  scopeId: string;
  dataType: string;
  bpValue: string;
  validUntil: string; 
  isSecured: boolean;
  bpscopedepartment: string;
  ScopeName : string;
}
interface formDataedit {
guid:string
    name: string;
    description: string;
    
    _DataType: string;
    bpValue: string;
    validUntil: string;
    isSecured: boolean;
}
interface formDatadelete {
  deleted: string,
                referenced: string,
                BusinessParameterGuid: string,
  }
const baseUrl = `${getBaseUrl()}/API/v3/BusinessParameters`;

export const businessParameterApi = createApi({
  reducerPath: 'businessParameterApi',
  baseQuery: getBaseQuery(baseUrl),
  endpoints: (builder) => ({
    GetBusinessParameter: builder.mutation<any, void>({
      query: () => ({
        url: '/GetBusinessParameters',
        method: 'GET',
      }),
      transformResponse: (response: any) => {
        return response?.data || []; 
      },
    }),
    GetParameter: builder.mutation<any, string>({
      query: (guid) => ({
        url: `/GetParameter`,
        method: 'GET',
        params: { Guid: guid }, 
      }),
      transformResponse: (response: any) => {
        return response?.data || []; 
      },
    }),
    
    addBusinessParameter: builder.mutation<any, formData>({
      query: (formData) => {
        const formattedData = new FormData();
    
        // Append fields to the FormData object
        formattedData.append('Name', formData.name);
        formattedData.append('Description', formData.description);
        formattedData.append('SourceId', formData.sourceId);
        formattedData.append('ScopeId', formData.scopeId);
        formattedData.append('DataType', formData.dataType);
        formattedData.append('BPValue', formData.bpValue);
        formattedData.append('ValidUntilString', formData.validUntil);
        formattedData.append('isSecured', formData.isSecured.toString());
        formattedData.append('ForDepartmentName', formData.bpscopedepartment);
        formattedData.append('ScopeName', formData.ScopeName);
        return {
          url: '',
          method: 'POST',
          body: formattedData, 
        };
      },
      transformResponse: (response: any) => {
        return response?.data || {}; 
      },
    }),
    EditBusinessParameter: builder.mutation<any, formDataedit>({
      query: (formData) => {
        const formattedData = new FormData();
    
        formattedData.append('Guid', formData.guid);

        formattedData.append('Name', formData.name);
        formattedData.append('Description', formData.description);
        
        
        formattedData.append('_DataType', formData._DataType);
        formattedData.append('BPValue', formData.bpValue);
        formattedData.append('ValidUntilString', formData.validUntil);
        formattedData.append('IsSecured', formData.isSecured.toString());
        
        return {
          url: '',
          method: 'PUT',
          body: formattedData,
        };
      },
      transformResponse: (response: any) => {
        return response?.data || {}; 
      },
    }),
    DeleteBusinessParameter: builder.mutation<any, formDatadelete>({
      query: (formData) => {
        const formattedData = new FormData();
    
        formattedData.append('deleted', formData.deleted);
        formattedData.append('referenced', formData.referenced);
        formattedData.append('BusinessParameterGuid', formData.BusinessParameterGuid);
        
        return {
          url: '',
          method: 'DELETE',
          body: formattedData, 
        };
      },
      transformResponse: (response: any) => {
        return response?.data || {}; 
      },
    }),
  }),
});

export const {
  useGetBusinessParameterMutation,
  useGetParameterMutation,
  useAddBusinessParameterMutation,
  useEditBusinessParameterMutation,
  useDeleteBusinessParameterMutation
} = businessParameterApi;

